import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { styled } from '@mui/material/styles'

const Root = styled('div')(({ theme }) => ({
    width: '100%',
    '& > * + *': {
        marginTop: theme.spacing(2),
    },
}))

const Toast = ({ showBanner, message }) => {
    if (!showBanner) return ''
    return (
        <Root>
            <Snackbar open={showBanner} autoHideDuration={6000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity="success" variant="filled" elevation={6}>
                    {message}
                </Alert>
            </Snackbar>
        </Root>
    )
}

export default Toast
